import { defineStore } from 'pinia';
import {
  ref,
} from 'vue';

import type { ITableState } from '@modules/tables/types';

const useAffiliateTrackersStore = defineStore('affiliate-trackers', () => {
  const trackersTableState = ref<ITableState>({ page: 1 });

  function updateTrackersTableState(state: ITableState): void {
    trackersTableState.value = state;
  }

  return {
    trackersTableState,
    updateTrackersTableState,
  };
});

export default useAffiliateTrackersStore;
